export const Error = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15000_7075)">
      <path
        d="M32.0002 58.6666C17.2722 58.6666 5.3335 46.728 5.3335 32C5.3335 17.272 17.2722 5.33331 32.0002 5.33331C46.7282 5.33331 58.6668 17.272 58.6668 32C58.6668 46.728 46.7282 58.6666 32.0002 58.6666ZM32.0002 28.2293L24.4588 20.6853L20.6855 24.4586L28.2295 32L20.6855 39.5413L24.4588 43.3146L32.0002 35.7706L39.5415 43.3146L43.3148 39.5413L35.7708 32L43.3148 24.4586L39.5415 20.6853L32.0002 28.2293Z"
        fill="#D43548"
      />
    </g>
    <defs>
      <clipPath id="clip0_15000_7075">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
